/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { useIntl } from 'react-intl'
import { KTSVG } from '../../../helpers'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'
import PermissionsGate from '../../../../app/pages/permissionsGate/PermissionsGate'

export function AsideMenuMain() {
  const intl = useIntl()

  return (
    <>
      <AsideMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title='แดชบอร์ด'
        fontIcon='bi-app-indicator'
      />
      <PermissionsGate pageName="intent" scopes={['view']}>
        <AsideMenuItem
          to="/intents"
          title="กลุ่มคำถาม"
          icon='/media/icons/duotune/communication/com012.svg'
        />
      </PermissionsGate>

      <PermissionsGate pageName="chat" scopes={['view']}>
        <AsideMenuItem
          to='/apps/chat'
          title='ประวัติการแชท'
          icon='/media/icons/duotune/communication/com012.svg'
        />
      </PermissionsGate>

      <PermissionsGate pageName="fallback" scopes={['view']}>
        <AsideMenuItem
          to='/false-message'
          title='ข้อความ False Message'
          icon='/media/icons/duotune/communication/com012.svg'
        />
      </PermissionsGate>

      <AsideMenuItemWithSub
        to='/report'
        title='รายงาน'
        icon='/media/icons/duotune/communication/com006.svg'
        fontIcon='bi-person'
      >
        <AsideMenuItem
          to='/report/report1'
          title='รายงานปริมาณการใช้งาน'
          icon='/media/icons/duotune/communication/com012.svg'
        />
        <AsideMenuItem
          to='/report/report2'
          title='รายงานการใช้งาน'
          icon='/media/icons/duotune/communication/com012.svg'
        />
        <AsideMenuItem
          to='/report/report3'
          title='รายงานสถิติคำถาม / คำตอบ'
          icon='/media/icons/duotune/communication/com012.svg'
        />
        <AsideMenuItem
          to='/report/report4'
          title='รายงาน False Message'
          icon='/media/icons/duotune/communication/com012.svg'
        />
        <AsideMenuItem
          to='/report/report5'
          title='รายงานการเข้าใช้งาน'
          icon='/media/icons/duotune/communication/com012.svg'
        />
      </AsideMenuItemWithSub>

      <PermissionsGate pageName="setting" scopes={['view']}>
        <AsideMenuItemWithSub
          to='/setting'
          title='ตั้งค่า'
          icon='/media/icons/duotune/communication/com006.svg'
          fontIcon='bi-person'
        >
          <AsideMenuItem
            to="/setting/users"
            title="ผุ้ใช้งาน"
            icon='/media/icons/duotune/Communication/com006.svg'
          />
          <PermissionsGate pageName="role" scopes={['view']}>
            <AsideMenuItem
              to="/setting/role_&_permission"
              title="สิทธิ์และการเข้าถึงระบบ"
              icon='/media/icons/duotune/General/gen049.svg'
            />
          </PermissionsGate>
          <AsideMenuItem
            to="/setting/chatbox"
            title="กล่องแชท"
            icon='/media/icons/duotune/General/gen049.svg'
          />
          <AsideMenuItem
            to="/setting/system"
            title="ข้อมูลระบบ"
            icon='/media/icons/duotune/General/gen049.svg'
          />
          <AsideMenuItem
            to="/setting/chat-plugin"
            title="Chat Plugin"
            icon='/media/icons/duotune/General/gen049.svg'
          />
        </AsideMenuItemWithSub>
      </PermissionsGate>

      <AsideMenuItem
        to='/poll'
        title='แบบสำรวจ'
        icon='/media/icons/duotune/communication/com012.svg'
      />

      {/* <div className='menu-item'>
        <div
          className='menu-link'
        >
          <span className='menu-title'>APP VERSION {process.env.REACT_APP_VERSION}</span>
        </div>
      </div> */}
    </>
  )
}
